const TEXT_KEYS = ["description", "risk", "flag", "ambiguity", "contradiction", "name", "term", "title", "value", "text"];

// Coerces any AI-produced value into something React can safely render as text
export const toText = (value: unknown): string => {
	if (value === null || value === undefined) return "";
	if (typeof value === "string") return value;
	if (typeof value === "number" || typeof value === "boolean") return String(value);
	if (Array.isArray(value)) return value.map(toText).filter(Boolean).join(", ");
	if (typeof value === "object") {
		const obj = value as Record<string, unknown>;
		for (const key of TEXT_KEYS) {
			if (typeof obj[key] === "string" && obj[key]) return obj[key] as string;
		}
		try {
			return JSON.stringify(value);
		} catch {
			return "";
		}
	}
	return "";
};

// Returns an array of renderable strings, whatever the AI returned (array, string, object, null)
export const toTextList = (value: unknown): string[] => {
	if (value === null || value === undefined) return [];
	const items = Array.isArray(value) ? value : [value];
	return items.map(toText).filter((item) => item !== "");
};

// Returns a finite number or null (used before computing percentages)
export const toNumber = (value: unknown): number | null => {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	return null;
};
